<div class="flex flex-col gap-2">
  <button
    (click)="handleAddress($event)"
    class="flex items-center w-full gap-2"
  >
    <input
      #inputRef
      type="text"
      class="w-full input"
      placeholder="주소 검색"
      [value]="value() || ''"
      [readonly]="true"
    />
    <button
      class="cursor-pointer btn text-zinc-400 bg-white shadow-none border border-zinc-200"
    >
      주소 검색
    </button>
  </button>
  @if (enableCoordinate()) {
  <div class="flex gap-3 items-center">
    <input class="w-full input" [(ngModel)]="lat" placeholder="위도" />
    <input class="w-full input" [(ngModel)]="lng" placeholder="경도" />
  </div>
  }
</div>
